export const presentationUrl = (url) => {
  const regex = new RegExp(/https:\/\/view.genial.ly\/([\w-]+)/g, 'g');
  if (!url) return '';

  const validUrl = url.match(regex);
  return validUrl?.[0] || '';
};
